/** Page size of the mutual/following/followers lists (mirrors SocialConstants.ListPageSize). */
export const SOCIAL_LIST_PAGE_SIZE = 20;

/** URL parameter carrying the 1-based page of the active social list tab. */
export const SOCIAL_LIST_PAGE_PARAM = "page";

/** URL parameter carrying the people-search term, so it survives back-navigation. */
export const SEARCH_TERM_PARAM = "search";
